import React from 'react';
import PropTypes from 'prop-types';
import { Spacing, Text, Icon } from '@reservamos/elements';
import './QuantitySelector.scss';

/**
 * QuantitySelector component.
 * @param {object} props - variant, type, onClickIncrement, onClickDecrement, counter, isDisabled, iconSize.
 * @param {function} props.onClickIncrement - Function to increment the counter.
 * @param {function} props.onClickDecrement - Function to decrement the counter.
 * @param {number} props.counter - The current passenger count.
 * @param {boolean} props.isIncreaseDisabled - Indicates if the increase button is disabled.
 * @param {boolean} props.isDecreaseDisabled - Indicates if the decrease button is disabled.
 */
function QuantitySelector({
  onClickIncrement,
  onClickDecrement,
  counter,
  isIncreaseDisabled,
  isDecreaseDisabled,
}) {
  return (
    <Spacing alignItems="center" size="XS">
      <button
        className={`quantity-button${isDecreaseDisabled ? '-disabled' : ''}`}
        onClick={onClickDecrement}
        disabled={isDecreaseDisabled}
      >
        <Icon type="LessSign" size="S" color={isDecreaseDisabled ? 'grayLight' : 'primary'} />
      </button>

      <div className="w-[30px]">
        <Text mobileSize="L" size="XL" weight="bold" textAlign="center">
          {counter}
        </Text>
      </div>

      <button
        className={`quantity-button${isIncreaseDisabled ? '-disabled' : ''}`}
        onClick={onClickIncrement}
        disabled={isIncreaseDisabled}
      >
        <Icon type="PlusSign" size="S" color={isIncreaseDisabled ? 'grayLight' : 'primary'} />
      </button>
    </Spacing>
  );
}

QuantitySelector.propTypes = {
  onClickIncrement: PropTypes.func.isRequired,
  onClickDecrement: PropTypes.func.isRequired,
  counter: PropTypes.number,
  isIncreaseDisabled: PropTypes.bool,
  isDecreaseDisabled: PropTypes.bool,
};

export default QuantitySelector;
